export const EVENT_SALE_PAST    =  0;
export const EVENT_SALE_FUTURE  = -1;
